import store from '@store';

export default {
  hasProviderId() {
    const roleType = store.state.currentUser?.providerId;
    return roleType != undefined;
  },
  isAdmin() {
    const roleType = store.state.userInformation.roleType;
    return roleType === 'ADMIN';
  },
  isGav() {
    const roleType = store.state.userInformation.roleType;
    return roleType === 'GAV';
  },
  isGas() {
    const roleType = store.state.userInformation.roleType;
    return roleType === 'GAS';
  },
  isGasGav() {
    const roleType = store.state.userInformation.roleType;
    return roleType === 'GAS' || roleType === 'GAV';
  },
  isOwner() {
    const roleType = store.state.userInformation.roleType;
    return roleType === 'OWNER';
  },
  isDeveloper() {
    const roleType = store.state.userInformation.roleType;
    return roleType === 'DEVELOPER';
  },
  isPrestataire() {
    const roleType = store.state.userInformation.roleType;
    return roleType === 'PRESTATAIRE';
  },
  isPartenaire() {
    const roleType = store.state.userInformation.roleType;
    return roleType === 'PARTENAIRE';
  },
  isHousekeeper() {
    const roleType = store.state.userInformation.roleType;
    return roleType === 'HOUSEKEEPER';
  },
  isCommercial() {
    const roleType = store.state.userInformation.roleType;
    return roleType === 'COMMERCIAL';
  },
  isMe(userId) {
    let tmp = store.state.userInformation.userId;
    return tmp === userId;
  },
  hasPermission(permission) {
    let permissions = store.state.userInformation.permissions;
    if (!permissions) return false;
    return permissions.includes(permission);
  },
  hasOneOfThem(permissions) {
    if (!permissions) return false;
    return permissions.some(this.hasPermission);
  },
  myUserId() {
    return store.state.userInformation.userId;
  },
  myEmployeeId() {
    return store.state.userInformation.employeeId;
  },
  myCompanyId() {
    return store.state.userInformation.companyId;
  },
  myOwnerId() {
    return store.state.userInformation.ownerId;
  },
  myPartenaireId() {
    return store.state.userInformation.partenaireId;
  },
  myHousekeeperId() {
    return store.state.userInformation.housekeeperId;
  },
  myCommercialId() {
    return store.state.userInformation.commercialId;
  },
  isOneOfThem(roles) {
    const roleType = store.state.userInformation.roleType;
    return roles.includes(roleType);
  },
  isPoleComptabiliteMandante() {
    return store.state.userInformation.isPoleComptabiliteMandante;
  },
  myUserInformation() {
    return store.state.userInformation;
  },
  myAccommodationIds() {
    return store.state.userInformation.accommodationIds;
  },
};
